import { render, staticRenderFns } from "./TextRecommendations.vue?vue&type=template&id=d9d8f71a&scoped=true"
import script from "./TextRecommendations.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextRecommendations.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextRecommendations.vue?vue&type=style&index=0&id=d9d8f71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d8f71a",
  null
  
)

export default component.exports